<div class="table-container">
  <div class="table-wrapper">
    @if (dataSource && dataSource.length > 0) {
    <table mat-table [dataSource]="dataSource" class="custom-border responsive-table">
      <tr mat-header-row *matHeaderRowDef="displayedColumnKeys"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnKeys;"></tr>

      @for (columnConfig of displayedColumns; track columnConfig.key; let index = $index) {
      <ng-container matColumnDef="{{columnConfig.key}}">
        <!-- Handle special legacy columns for backward compatibility -->
        @if (columnConfig.key == 'job name') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element" 
            [matTooltip]="element['description'] || ''" 
            matTooltipClass="job-description-tooltip"
            matTooltipPosition="above">
          @if (isNavigableJob(element)) {
            <button 
              (click)="navigateIfNavigable(element)"
              (keydown.enter)="navigateIfNavigable(element)"
              (keydown.space)="navigateIfNavigable(element)"
              class="cursor-pointer text-utility-link underline bg-transparent border-0 p-0 text-left"
              [attr.aria-label]="'Navigate to search by job ID ' + element.job_id">
              {{element['name'] || '--'}}
            </button>
          } @else {
            {{element['name'] || '--'}}
          }
        </td>
        } @else if (columnConfig.key == 'type') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element" (dblclick)="openDialog(element)">
          {{element['job_type']?.['name'] || '--'}}
        </td>
        } @else if (columnConfig.key == 'thumbnails') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element" class="image flex flex-row">
          @if (isNavigableJob(element)) {
            <div 
              class="flex flex-row cursor-pointer"
              role="button"
              tabindex="0"
              [attr.aria-label]="'Navigate to search by job ID ' + element.job_id"
              (click)="navigateIfNavigable(element)"
              (keydown.enter)="navigateIfNavigable(element)"
              (keydown.space)="navigateIfNavigable(element)">
              @for (task of element.tasks || []; track task; let index = $index) {
              @if (index < 3) { <dal-shared-ui-media-renderer [url]="task.thumbnail"
                [authenticateUrl]="task.thumbnail && !task.thumbnail.startsWith('blob:') && task.asset_type_id !== AssetTypeId.Audio" [type]="'image'"
                [customClass]="'h-[40px] w-[50px] mt-3 mb-2 mr-[5px]'"></dal-shared-ui-media-renderer>
                }
                }
                <div class="text min-h-[40px] mt-5">{{(element.tasks?.length || 0)}} total</div>
            </div>
          } @else {
            <div class="flex flex-row">
              @for (task of element.tasks || []; track task; let index = $index) {
              @if (index < 3) { <dal-shared-ui-media-renderer [url]="task.thumbnail"
                [authenticateUrl]="task.thumbnail && !task.thumbnail.startsWith('blob:') && task.asset_type_id !== AssetTypeId.Audio" [type]="'image'"
                [customClass]="'h-[40px] w-[50px] mt-3 mb-2 mr-[5px]'"></dal-shared-ui-media-renderer>
                }
                }
                <div class="text min-h-[40px] mt-5">{{(element.tasks?.length || 0)}} total</div>
            </div>
          }
        </td>
        } @else if (columnConfig.key == 'status' && title !== 'Users') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="icon-text-container">
            @if (element.status?.name != 'Success' && element.status?.name != 'Failed') {
            <mat-icon class="mr-1 animate-spin" svgIcon="arrow-repeat"></mat-icon>
            @if (dialogLink) {
            <button (click)="openDialog(element)" class="text-utility-link underline">{{element.status?.name || '--'}}</button>
            } @else {
            <span>{{element.status?.name || '--'}}</span>
            }
            } @else if (element.status?.name == 'Success') {
            @if (dialogLink) {
            <mat-icon class="mr-1 text-icon-success">check_circle</mat-icon>
            <button (click)="openDialog(element)" class="text-utility-link underline">{{element.status?.name}}</button>
            }
            } @else if (element.status?.name == 'Failed') {
            @if (dialogLink) {
            @if (isPartialFailure(element)) {
            <mat-icon class="mr-1 flex-shrink-0 text-warning">warning</mat-icon>
            <div class="flex flex-col">
              <button (click)="openDialog(element)" class="text-utility-link underline text-left">Partial Failure</button>
              <span class="text-xs text-muted leading-tight mt-0.5">
                {{getFailedTaskCount(element)}} of {{element.tasks?.length}} assets failed
              </span>
            </div>
            } @else {
            <mat-icon class="mr-1 flex-shrink-0" svgIcon="exclamation-square-fill"></mat-icon>
            <div class="flex flex-col">
              <button (click)="openDialog(element)" class="text-utility-link underline text-left">{{element.status?.name}}</button>
            </div>
            }
            }
            }
          </div>
        </td>
        } @else if (columnConfig.key == 'user') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          {{element['created_by']}}
        </td>
        } @else if (columnConfig.key == 'start time') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          {{element['start_time'] | date: 'MM/dd/yyyy'}}<br />
          {{element['start_time'] | date: 'HH:mm:ss'}}
        </td>
        } @else if (columnConfig.key == 'end time') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          {{element['end_time'] | date: 'MM/dd/yyyy'}}<br />
          {{element['end_time'] | date: 'HH:mm:ss'}}
        </td>
        } @else if (columnConfig.key == 'actions' && title !== 'Users') {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          @if (element.status?.name === 'Success' ) {
          <button type="button"
            class="border border-[#2693A6] rounded-md w-8 h-8 flex items-center justify-center hover:bg-[#e6f7fa] transition"
            aria-label="Download" matTooltip="Ingestion Report" (click)="triggerDownload(element)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#2693A6" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="M12 5v16" />
              <path d="M6 13l6 6 6-6" />
              <path d="M1 21h22" />
            </svg>
          </button>
          }
        </td>
        } @else if (columnConfig.type === 'status') {
        <th mat-header-cell *matHeaderCellDef [style.width]="columnConfig.width || 'auto'">
          @if (enableSorting) {
          <div class="sort-header">
            <div class="sort-icon-container">
              <svg (click)="toggleSort('asc', columnConfig.key)" class="sort-icon up-arrow"
                [ngClass]="{'active': sortOrder === 'asc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 -6 24 24">
                <path
                  d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z">
                </path>
              </svg>
              <svg (click)="toggleSort('desc', columnConfig.key)" class="sort-icon down-arrow"
                [ngClass]="{'active': sortOrder === 'desc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                <path
                  d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z">
                </path>
              </svg>
            </div>
            <div class="sort-text">
              {{ columnConfig.header }}
            </div>
          </div>
          } @else {
          {{ columnConfig.header }}
          }
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            [class]="element[columnConfig.key] === 'Active' ? 'text-green-600 font-medium' : 'text-red-600 font-medium'">
            {{ element[columnConfig.key] }}
          </span>
        </td> } @else if (columnConfig.type === 'actions' && (title === 'Users' || customActions.length > 0)) {
        <th mat-header-cell *matHeaderCellDef> {{columnConfig.header}} </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" [matMenuTriggerFor]="actionMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu">
            @if (title === 'Users') {
            <!-- Users-specific menu items -->
            <button mat-menu-item (click)="onActionClick('edit', element)">
              <span>Edit</span>
            </button>
            <mat-divider></mat-divider>
            <div class="flex items-center justify-between px-4 py-2">
              <span class="text-sm mr-3">Active</span>
              <mat-slide-toggle [checked]="element.status === 'Active'" (change)="onActionClick('toggle', element)"
                color="primary">
              </mat-slide-toggle>
            </div>
            } @else if (customActions.length > 0) {
            <!-- Custom actions for other components -->
            @for (action of getFilteredActions(element); track action.action) {
            <button mat-menu-item (click)="onActionClick(action.action, element)">
              <mat-icon>{{action.icon}}</mat-icon>
              <span>{{action.label}}</span>
            </button>
            }
            }
          </mat-menu>
        </td>
        } @else if (columnConfig.type === 'date') {
        <th mat-header-cell *matHeaderCellDef [style.width]="columnConfig.width || 'auto'">
          @if (enableSorting) {
          <div class="sort-header">
            <div class="sort-icon-container">
              <svg (click)="toggleSort('asc', columnConfig.key)" class="sort-icon up-arrow"
                [ngClass]="{'active': sortOrder === 'asc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 -6 24 24">
                <path
                  d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z">
                </path>
              </svg>
              <svg (click)="toggleSort('desc', columnConfig.key)" class="sort-icon down-arrow"
                [ngClass]="{'active': sortOrder === 'desc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                <path
                  d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z">
                </path>
              </svg>
            </div>
            <div class="sort-text">
              {{ columnConfig.header }}
            </div>
          </div>
          } @else {
          {{ columnConfig.header }}
          }
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element[columnConfig.key] | date: 'MMM dd, yyyy' }}
        </td>
        } @else {
        <!-- Default text column with flexible header and sorting -->
        <th mat-header-cell *matHeaderCellDef [style.width]="columnConfig.width || 'auto'">
          @if (enableSorting) {
          <div class="sort-header">
            <div class="sort-icon-container">
              <svg (click)="toggleSort('asc', columnConfig.key)" class="sort-icon up-arrow"
                [ngClass]="{'active': sortOrder === 'asc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 -6 24 24">
                <path
                  d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z">
                </path>
              </svg>
              <svg (click)="toggleSort('desc', columnConfig.key)" class="sort-icon down-arrow"
                [ngClass]="{'active': sortOrder === 'desc' && sortColumn === columnConfig.key}"
                xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                <path
                  d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z">
                </path>
              </svg>
            </div>
            <div class="sort-text">
              {{ columnConfig.header }}
            </div>
          </div>
          } @else {
          {{ columnConfig.header }}
          }
        </th>
        <td mat-cell *matCellDef="let element">
          @if (columnConfig.key === 'business_units') {
          <span [title]="element[columnConfig.key]" class="truncate block max-w-xs">
            {{ element[columnConfig.key] }}
          </span>
          } @else {
          {{ element[columnConfig.key] }}
          }
        </td>
        }
      </ng-container>
      }
    </table>
    } @else {
    <!-- No data state -->
    <div class="no-data-container">
      <div class="no-data-message">
        <mat-icon class="no-data-icon">inbox</mat-icon>
        <h3>No records found</h3>
        <p>There are no items to display at this time.</p>
      </div>
    </div>
    }
  </div>
</div>